<template>
  <store-details/>
</template>
<script>
import StoreDetails from '../components/page-components/stores/StoreDetails'
export default {
  components: { StoreDetails }
}
</script>
